import { useMutation } from '@tanstack/react-query';
import { getTicketsInJudgment } from '../requests/ticketsInJudgment.request';
import {
  TicketsInJudgmentRequest,
  TicketsInJudgmentResponse
} from '../types/ticketsInJudgment.types';
import toast from 'react-hot-toast';
import { AxiosError } from 'axios';

export const useTicketsInJudgmentQuery = () => {
  return useMutation<TicketsInJudgmentResponse, AxiosError, TicketsInJudgmentRequest>({
    mutationKey: ['tickets-in-judgment'],
    mutationFn: getTicketsInJudgment,
    onError: (error) => {
      toast.error(error.message || 'Failed to fetch tickets in judgment');
    }
  });
};
